import httpRequest from "../utils/axios.js";
import config from "./config.js";

export default {
  getCoupons,
  getUserInfo,
  userRegister,
  getCode,
  getOrders,
  getUsedCoupons
};
/**
 * 获取用户信息
 */
export function getUserInfo() {
  var url = config.user;
  var jsondata = {};
  return httpRequest.fetchPost(url, jsondata);
}
/**
 * 查券
 */
export function getCoupons(couponsStatus) {
  var url = config.qcoupons;
  // console.log(couponsStatus);
  var jsondata = {
    current: 1,
    size: 100,
    status: couponsStatus
  };
  return httpRequest.fetchGetJson(url, jsondata);
}
/**
 * 用户注册
 */
export function userRegister(phone, code, type) {
  var url = config.register;
  var jsondata = {
    mobile: phone,
    captcha: code,
    isUpdate: type
  };
  return httpRequest.fetchPost(url, jsondata);
}
/**
 * 获取验证码
 */
export function getCode(phone, type) {
  var url = config.getCode + phone;
  var jsondata = {
    type: type
  };
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 获取订单
 */
export function getOrders(current, orderStatus, size = 10) {
  var url = config.getOrders;
  var jsondata = {
    current: current,
    size: size,
    orderStatus: orderStatus
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取已用礼券
 */
export function getUsedCoupons(current, size = 10) {
  var url = config.getUsedCoupons;
  var jsondata = {
    current: current,
    size: size
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 校验验证码
 */
export function checkCode(captcha) {
  var url = config.checkCode;
  var jsondata = {
    captcha: captcha
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取用户待支付订单数量
 * @returns
 */
export function getUserWaitPayOrdersCount() {
  var url = config.getUserWaitPayOrdersCount;
  var jsondata = {};
  return httpRequest.fetchGet(url, jsondata);
}

/**
/*
查订单
GET
/api/v1.0/wechat/orders
@param  current  当前页
@param  size 分页大小
@param  orderStatus （0：待处理，1：失败，2：已完成）ps: 不传查所有
*/
/**
 * 获取订单
 */
export function getWithdraw(current, orderStatus, size = 10) {
  var url = config.getWithdraw;
  var jsondata = {
    current: current,
    size: size,
    status: orderStatus
  };
  return httpRequest.fetchGet(url, jsondata);
}

export function getCouponsByIdApi(couponId) {
  var url = '/api/v1.0/wechat/user/coupon/' + couponId
  return httpRequest.fetchGet(url);
}